module.exports = __webpack_public_path__ + "static/media/Sophie Himsworth Alcove Units (3).3cc14c6b.jpg";